
const ENContractItems = {
	"Adicionar Item de Contrato" : "Add Contract Item",
	"Ações Relacionadas": "Related Actions",
	"Alterar Item de Contrato" : "Update Contract Item",
	"Descrição do item não confere" : "Description of the item does not match",
	"Deseja realmente excluir o item de contrato" : "Do you really want to delete the Contract Item",
	"Digite a descrição do item de contrato para excluí-lo" : "Enter the description of the Contract Item to delete it",
	"Erro ao adicionar item de contrato" : "Error adding Contract Item",
	"Erro ao alterar item de contrato" : "Error changing Contract Item",
	"Erro ao excluir item de contrato" : "Error deleting Contract Item",
	"Este código já está cadastrado" : "This code already exists",
	"Exclusão de item de contrato" : "Delete Contract Item",
	"Item de contrato adicionado com sucesso" : "Contract Item successfully added",
	"Item de contrato alterado com sucesso" : "Contract Item successfully changed",
	"Item de contrato excluído com sucesso" : "Contract Item successfully deleted",
	"Item de contrato" : "Contract Item",
	"Itens de contrato" : "Contract Items",
	"Itens de Contrato" : "Contract Items",
	"Novo item de contrato" : "New Contract Item"
};

export default ENContractItems;
